import { Grid } from "@mui/material";
import { ExamCard } from "../../../components/ExamCard/ExamCard";
import { getAllBilet } from "../../../utils/API/biletMethod";
import { useEffect, useState } from "react";
import { useNavigate, useParams, useSearchParams } from "react-router";
import { usePortal, useTestStore } from "../../../hooks/store";
import { testType } from "../../../utils/testHelper";
import Styles from "./home.module.css";
export function Main() {
  const [BiletList, setBiletList] = useState([]);
  const nav = useNavigate();
  const testStore = useTestStore();
  const [params, setSearchParams] = useSearchParams();

  const navToSolve = (id, title) => {
    nav(`../test?testType=${testType.bilet.type}&id=${id}&title=${title}`);
  };
  const LoadingPortal = usePortal();
  useEffect(() => {
    const getPageData = async () => {
      return await getAllBilet();
    };

    LoadingPortal.setPortal();

    getPageData().then(({ data }) => {
      LoadingPortal.closePortal();
      setBiletList(data);
    });
  }, []);

  return (
    <div className={Styles.card_grid}>
      {BiletList.map((bilet) => {
        const { name, id, question_count, solved } = bilet;
        return (
          <ExamCard
            type={testType.bilet.type}
            size={1}
            title={name}
            questions={question_count}
            solved={solved}
            onClick={() => navToSolve(id, name)}
            biletId={id}
          />
        );
      })}
    </div>
    // <Grid
    //   container
    //   spacing={4}
    //   sx={{ height: "fit-content" }}
    //   columns={6}
    //   className={Styles.grid}>
    //   {BiletList.map((bilet) => {
    //     const { name, id, question_count, solved } = bilet;
    //     return (
    //       <ExamCard
    //         type={testType.bilet.type}
    //         size={1}
    //         title={name}
    //         questions={question_count}
    //         solved={solved}
    //         onClick={() => navToSolve(id, name)}
    //         biletId={id}
    //       />
    //     );
    //   })}
    // </Grid>
  );
}
